export const BaseUrl = process.env.REACT_APP_API_LIVE_BASE_URL;

// JWT TOKEN
export const RefreshTokenUrl = BaseUrl + "jwt-token-refresh";

// Login
export const LoginClientAuth = BaseUrl + "login-client-auth";
export const GetCaptcha = BaseUrl + "login-client-captcha";
export const getloginProductCategory = BaseUrl + "get-product-category-login";
export const logout = BaseUrl + "logout-client";

// OTP
export const OtpVerify = BaseUrl + "login-otp-verify";
export const OtpResend = BaseUrl + "login-otp-resend";

// Forget Customer ID
// export const forgotClientAuth = BaseUrl + "forgot-client-auth";

// Forget Customer ID OTP Varify
// export const ClientOtpVerify = BaseUrl + "forgot-client-otp-verify";

// Profile
export const getUserProfile = BaseUrl + "get-client-profile";
export const setUserProfile = BaseUrl + "set-client-Profile";
export const getUserContactDtl = BaseUrl + "get-client-Contact-dtl";
export const setUserContactDtl = BaseUrl + "set-client-Contact-dtl";
// export const setCbsVendor = BaseUrl + "get-cbs-vendor";
export const setDesignation = BaseUrl + "get-designation";

// Dashboard
export const DashboardCount = BaseUrl + "get-client-product-count";
export const getProductServiceTable = BaseUrl + "get-client-product-service";
export const getProductServiceLink = BaseUrl + "get-link-product-service";
export const getClientDocuments = BaseUrl + "get-client-document";
export const getClientDtl = BaseUrl + "get-client-agent-dtl";
export const getEscalationMatrix = BaseUrl + "get-product-escalation-matrix";

export const getDashboardProductList = BaseUrl + "get-product"; // also used in create ticket pages
export const getClientOrderQuotation = BaseUrl + "get-client-order-quotation"; // also used in create ticket pages
export const setClientOrderQuotation = BaseUrl + "set-client-order-quotation"; // also used in create ticket pages
export const getClientOrderQuotationPrintView = BaseUrl + "get-client-order-quotation-print-view"; // also used in create ticket pages
export const addClientOrderQuotation = BaseUrl + "add-client-order-quotation"; // also used in create ticket pages


export const getProductCategory = BaseUrl + "get-product-category";

// News and Knowledge
export const getNewsKnowledge = BaseUrl + "get-client-news";

// Help
export const getClientHelpDocuments = BaseUrl + "get-client-help-document";

// Inquiry
export const getProductInquiry = BaseUrl + "get-product-inquiry";
export const setProductInquiry = BaseUrl + "set-product-inquiry";

// Invoice
export const getClientInvoice = BaseUrl + "get-client-invoice";
export const getClientInvoiceDtl = BaseUrl + "get-client-invoice-view";

// Due Payment
export const getDuePaymentDetails = BaseUrl + "get-client-due-invoice";

// Duw Invoice Payment
export const getDueInvoicePayment = BaseUrl + "get-client-due-invoice-payment";

// Payment
export const getPaymentDtl = BaseUrl + "get-client-payment-dtl";

// Item List
export const getItemList = BaseUrl + "get-items";

// Order Details
export const getOrderDetail = BaseUrl + "get-client-order";

// Implemention Details
export const getImplementionDetails = BaseUrl + "get-client-implement";

// Review
// export const getClientReview = BaseUrl + "get-client-review";
export const setClientReview = BaseUrl + "set-client-review";

// Support
export const getTicket = BaseUrl + "get-ticket";
// export const getTicketDepartment = BaseUrl + "get-ticket-dprt";
// export const getTicketDepartmentProduct = BaseUrl + "get-ticket-dprt-product";
export const updateReadStatus = BaseUrl + "update-ticket-read-status";

// Support : Create Ticket
export const setTicket = BaseUrl + "set-ticket";
// Support : View Ticket
export const getTicketStatus = BaseUrl + "get-ticket-status";
export const setTicketPost = BaseUrl + "set-ticket-post";
export const setTicketStatus = BaseUrl + "update-ticket-status";
export const getTicketPost = BaseUrl + "get-ticket-post";
export const getTicketDtl = BaseUrl + "get-ticket-dtl";
export const downloadTicketAttach = BaseUrl + "download-ticket-attach";

// District/State/Country
// export const getcountrylistUrl = BaseUrl + "get-country";
// export const getstatelistUrl = BaseUrl + "get-state";
// export const getdistrictlistUrl = BaseUrl + "get-district";

// Other Remider
export const setClientVeder = BaseUrl + "set-client-vender";
export const getClientVeder = BaseUrl + "get-client-vender";

export const setClientVederProduct = BaseUrl + "set-client-vender-product";
export const getClientVederProduct = BaseUrl + "get-client-vender-product";
export const setClientVederName = BaseUrl + "set-client-vender-name";
export const getClientVederName = BaseUrl + "get-client-vender-name";

export const setDeleteVender = BaseUrl + "del-client-vender";
export const updateClientVender = BaseUrl + "upd-client-vender";
